// extracted by mini-css-extract-plugin
export default {"appbar":"Home_appbar__npLFw","homeLogo":"Home_homeLogo__5Qopq"};